// ProductInfoDialog.tsx
import * as React from 'react'
import { Dialog, DialogTitle, DialogContent, IconButton, useMediaQuery, useTheme } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import ProductInfoCard from 'components/ui/product-info-card'
import { useEntitiesFromSearch } from 'api/search'
import { OrganizationTableItem } from 'types'

type Props = {
  open: boolean
  item: OrganizationTableItem | null
  onClose: () => void
  title?: string
}

export default function ProductInfoDialog({ open, onClose, item, title = 'Product Details' }: Props) {
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'))
  const { products } = useEntitiesFromSearch()
  const selected = React.useMemo(() => {
    if (!products || !item) return null
    return products?.find(p => p?.SK === item?.SK) ?? null
  }, [products, item])
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      fullScreen={fullScreen}
      PaperProps={{ sx: { borderRadius: 3, p: 1 } }}
    >
      <DialogTitle sx={{ pr: 6 }}>
        <IconButton aria-label="close" onClick={onClose} sx={{ position: 'absolute', right: 8, top: 8 }} size="small">
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>{selected && <ProductInfoCard item={selected} />}</DialogContent>
    </Dialog>
  )
}
